module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/premiumLogo-076ab59ddbdd57a2237c8c11a439fa88.png";